export const ChartCurve = {
    smooth: 'smooth',
    straight: 'straight',
    stepline: 'stepline',
}
